import styles from './styles.module.scss';

export const InvitationClient = () => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.title}>招待カード</div>
        <div className={styles.description}>印刷して従業員に配布してください。</div>
      </div>
      <div className={styles.cardWrapper}>
        {Array.from(Array(12)).map((_, i) => (
          <div className={styles.card} key={i}>
            カード{i}
          </div>
        ))}
      </div>
    </div>
  );
};
